/*@flow*/
import checkbox from './CheckBox';
import date from './DateTime';
import list from './List';
import radio from './Radio';
import select from './Select';
import struct from './Struct';
import textbox from './Textbox';
import * as registry from './registry';

export default {
  checkbox,
  date,
  list,
  radio,
  select,
  struct,
  textbox,
  registry,
};
